import React, { useState } from 'react';

const CollapsiblePanel = ({ title, children, defaultExpanded = false }) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded); // Use prop for default state

  const togglePanel = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="collapsible-panel">
      <div className="panel-header" onClick={togglePanel}>
        <h3>{title}</h3>
        <span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      {isOpen && <div className="panel-content">{children}</div>}
    </div>
  );
};

export default CollapsiblePanel;